module.exports = __webpack_public_path__ + "img/wuxing.1464363a.png";